const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useProgress } = window.BAO.Carousel.plugins

class CardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.setupBodyAlignment()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.bodyResizeObserver?.disconnect()
  }

  static get basePerView () {
    return 1.25
  }

  static get slideTiers () {
    return [
      { media: '(min-width: 600px)', perView: 1.8 },
      { media: '(min-width: 768px)', perView: 2.2 },
      { media: '(min-width: 901px)', perView: 3.2 },
      { media: '(min-width: 1201px)', perView: 4.2 },
    ]
  }

  static get slideSpacing () {
    return 4
  }

  static get minFillCount () {
    return 3
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const slideCount = this.els.slide.elements.length
    const fillsWidth = slideCount >= CardCarousel.minFillCount

    const slidesConfig = perView => ({
      perView: fillsWidth ? Math.min(perView, slideCount) : perView,
      spacing: CardCarousel.slideSpacing,
    })

    const breakpoints = Object.fromEntries(
      CardCarousel.slideTiers.map(({ media, perView }) => [
        media,
        { slides: slidesConfig(perView) },
      ]),
    )

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: slidesConfig(CardCarousel.basePerView),
        breakpoints,
        created: slider => this.updateFit(slider),
        updated: slider => this.updateFit(slider),
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  updateFit (slider) {
    const fits = (slider.track?.details?.maxIdx ?? 0) <= 0

    this.els.slides.element.classList.toggle('car-Carousel_Carousel-centred', fits)
    this.els.progress?.element.setAttribute('aria-hidden', fits)
  }

  setupBodyAlignment () {
    if (!this.els.bodyGroup?.exists) return

    this.bodyResizeObserver = new ResizeObserver(() => {
      this.updateBodyAlignment()
    })

    this.els.bodyGroup.elements.forEach(bodyGroup => {
      this.bodyResizeObserver.observe(bodyGroup)
    })

    this.updateBodyAlignment()

    const fontsReady = document.fonts?.ready ?? Promise.resolve()

    fontsReady.then(() => {
      if (!this.isConnected) return

      this.bodyAlignmentCanReveal = true
      this.updateBodyAlignment()
    })
  }

  updateBodyAlignment () {
    const bodyHeight = Math.max(
      ...this.els.bodyGroup.elements.map(bodyGroup => (
        bodyGroup.getBoundingClientRect().height
      )),
    )

    if (!bodyHeight) return

    this.style.setProperty('--CardCarousel_BodyHeight', `${bodyHeight}px`)

    if (this.bodyAlignmentCanReveal) {
      this.classList.add('car-Carousel-bodyAligned')
    }
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel)
}
